import React, { useState } from "react";
import "../styles/Register.css";
import registerImg from "../assets/img/bg_1.jpg";
import { FaPaperPlane, FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { handleLogin } = useAuth();
  const navigate = useNavigate();

  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    if (!emailLogin.trim()) {
      toast.error("Email is required.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailLogin)) {
      toast.error("Enter a valid email address.");
      return false;
    }
    if (!passwordLogin.trim()) {
      toast.error("Password is required.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const payload = {
      emailLogin: emailLogin.trim(),
      passwordLogin: passwordLogin.trim(),
    };

    const response = await handleLogin(payload);
    setLoading(false);

    if (response.success) {
      toast.success("Login successful!");
      navigate("/");
    } else {
      toast.error(response.message || "Login failed.");
    }
  };

  return (
    <div className="register-wrapper">
      <div className="register-bg">
        <img src={registerImg} alt="Login" />
      </div>

      <div className="register-form-container flip-in-left">
        <h3 className="form-title">Sign In</h3>
        <form className="register-form" onSubmit={handleSubmit}>
          {/* Email */}
          <div className="floating-input">
            <input
              type="email"
              id="email"
              value={emailLogin}
              onChange={(e) => setEmailLogin(e.target.value)}
              required
            />
            <label htmlFor="email">Email Address</label>
          </div>

          {/* Password */}
          <div className="floating-input password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={passwordLogin}
              onChange={(e) => setPasswordLogin(e.target.value)}
              required
            />
            <label htmlFor="password">Password</label>
            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {/* Forgot Password */}
          <div className="text-end">
            <a href="/forgot-password" className="forgot-link">
              Forgot Password?
            </a>
          </div>

          {/* Login Button */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <p className="mb-0">
              Don't have an account? <a href="/register">Register</a>
            </p>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "..." : <FaPaperPlane />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
